import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "rounded-2xl border border-gray-100 bg-white shadow-sm p-6 text-left" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-start justify-between gap-4 mb-5"
}
const _hoisted_3 = {
  key: 0,
  class: "text-lg font-bold text-gray-900"
}
const _hoisted_4 = {
  key: 1,
  class: "text-sm text-gray-500 mt-1"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsCard',
  props: {
    title: {},
    description: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.title || _ctx.$slots.action)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.title), 1))
              : _createCommentVNode("", true),
            (_ctx.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.description), 1))
              : _createCommentVNode("", true)
          ]),
          _renderSlot(_ctx.$slots, "action")
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})